/** Rutas con shell Nutrimatic operativo (sin bottom nav, scroll lock propio). */
export function isNutrimaticOperationalRoute(pathname: string): boolean {
  if (pathname === '/swap') return true
  if (pathname === '/add' || pathname.startsWith('/add/')) return true
  if (pathname.startsWith('/remove/')) return true
  if (pathname === '/import' || pathname.startsWith('/import/')) return true
  return false
}

/** Rutas con chrome mínimo embed/diagnostics. */
export function isMinimalChromePath(pathname: string): boolean {
  return pathname.startsWith('/embed') || pathname.startsWith('/diagnostics')
}

/** Shell browse móvil con bottom nav + platform scroll lock. */
export function isMobileBrowseShellRoute(pathname: string): boolean {
  return !isMinimalChromePath(pathname) && !isNutrimaticOperationalRoute(pathname)
}
